export const EMAIL_TEMPLATE_NAMES = [
  'SignUp',
  'ForgotPassword',
  'PasswordChanged',
  'ProfileStatusChange',
  'AccountCreated',
  'AccountStatusChange',
  'AccountLeverageChange',
  'DocumentStatusChange',
  'DocumentExpired',
  'DocumentRenewReminder',
  'TransactionCreated',
  'TransactionStatusChange',
];

export const ISO_639_1_LANGUAGE_CODES = [
  'aa', 'ab', 'ae', 'af', 'ak', 'am', 'an', 'ar', 'as', 'av', 'ay', 'az',
  'ba', 'be', 'bg', 'bh', 'bi', 'bm', 'bn', 'bo', 'br', 'bs',
  'ca', 'ce', 'ch', 'co', 'cr', 'cs', 'cu', 'cv', 'cy',
  'da', 'de', 'dv', 'dz',
  'ee', 'el', 'en', 'eo', 'es', 'et', 'eu',
  'fa', 'ff', 'fi', 'fj', 'fo', 'fr', 'fy',
  'ga', 'gd', 'gl', 'gn', 'gu', 'gv',
  'ha', 'he', 'hi', 'ho', 'hr', 'ht', 'hu', 'hy', 'hz',
  'ia', 'id', 'ie', 'ig', 'ii', 'ik', 'io', 'is', 'it', 'iu',
  'ja', 'jv',
  'ka', 'kg', 'ki', 'kj', 'kk', 'kl', 'km', 'kn', 'ko', 'kr', 'ks', 'ku', 'kv', 'kw', 'ky',
  'la', 'lb', 'lg', 'li', 'ln', 'lo', 'lt', 'lu', 'lv',
  'mg', 'mh', 'mi', 'mk', 'ml', 'mn', 'mr', 'ms', 'mt', 'my',
  'na', 'nb', 'nd', 'ne', 'ng', 'nl', 'nn', 'no', 'nr', 'nv', 'ny',
  'oc', 'oj', 'om', 'or', 'os',
  'pa', 'pi', 'pl', 'ps', 'pt',
  'qu',
  'rm', 'rn', 'ro', 'ru', 'rw',
  'sa', 'sc', 'sd', 'se', 'sg', 'si', 'sk', 'sl', 'sm', 'sn', 'so', 'sq', 'sr', 'ss', 'st', 'su', 'sv', 'sw',
  'ta', 'te', 'tg', 'th', 'ti', 'tk', 'tl', 'tn', 'to', 'tr', 'ts', 'tt', 'tw', 'ty',
  'ug', 'uk', 'ur', 'uz',
  've', 'vi', 'vo',
  'wa', 'wo',
  'xh',
  'yi', 'yo',
  'za', 'zh', 'zu',
];

export function mapEmailTemplateResponseToDto(payload, fallbackName, fallbackLanguage = 'en') {
  return {
    id: String(payload?.id || '').trim(),
    jurisdictionId: String(payload?.jurisdictionId || '').trim(),
    name: String(payload?.name || fallbackName || '').trim(),
    language: String(payload?.language || fallbackLanguage || '').trim().toLowerCase(),
    subject: String(payload?.subject || '').trim(),
    html: String(payload?.html || '').trim(),
  };
}

function normalizeTemplates(payload) {
  const candidates = [
    payload?.templates,
    payload?.items,
    payload?.data,
    payload,
  ];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate;
    }

    if (candidate && typeof candidate === 'object') {
      const values = Object.values(candidate);
      if (values.length > 0 && values.some((item) => item && typeof item === 'object' && ('id' in item || 'name' in item))) {
        return values;
      }
    }
  }

  return [];
}

export function mapJurisdictionEmailTemplatesResponseToDto(payload) {
  return normalizeTemplates(payload).map((item, index) => {
    const id = String(item?.id || `email-template-${index}`).trim();
    return {
      id,
      name: String(item?.name || '').trim(),
      language: String(item?.language || '').trim().toLowerCase(),
      subject: '',
      html: '',
    };
  }).filter((item) => item.id);
}

export function mapEmailTemplatesWrapResponseToDto(payload) {
  return {
    header: String(payload?.header || ''),
    footer: String(payload?.footer || ''),
  };
}

export function mapPlaceholdersResponseToDto(payload) {
  const source = payload?.placeholders ?? payload?.items ?? payload?.data ?? payload;
  const values = [];

  if (Array.isArray(source)) {
    source.forEach((item) => {
      const value = String(item || '').trim();
      if (value) {
        values.push(value);
      }
    });
  } else if (source && typeof source === 'object') {
    Object.entries(source).forEach(([key, rawValue]) => {
      const value = String(rawValue || '').trim() || String(key || '').trim();
      if (value) {
        values.push(value);
      }
    });
  }

  return Array.from(new Set(values));
}
